var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.333 8.75c-.51 0-.97.311-1.16.786l-3.334 8.333a1.3 1.3 0 0 0-.089.464v10c0 .69.56 1.25 1.25 1.25h2.257a4.582 4.582 0 0 0 8.82 0h7.847a4.583 4.583 0 0 0 8.819 0H35c.69 0 1.25-.56 1.25-1.25v-6.666a4.583 4.583 0 0 0-4.583-4.584H30.6L24.309 9.22a1.25 1.25 0 0 0-.976-.469zm24.41 18.333h1.007v-5.416a2.083 2.083 0 0 0-2.083-2.084H6.25v7.5h1.007a4.583 4.583 0 0 1 8.82 0h7.847a4.584 4.584 0 0 1 8.819 0M9.583 28.34v-.011a2.083 2.083 0 1 1 0 .011m9.167-11.256H6.846L9.18 11.25h9.57zm2.5 0V11.25h1.483l4.666 5.833zm7.083 9.167a2.083 2.083 0 1 0 0 4.167 2.083 2.083 0 0 0 0-4.167",
    clipRule: "evenodd"
  })));
};
export default SvgCar;